import React from 'react';
import BlankComponent from '../BlankComponent/BlankComponent';
import NavLink from 'react-router-dom/es/NavLink';

const toolsWidget = () => (
  <BlankComponent>
    <div className="tools-widget__header">Tools</div>
    <div className="tools-widget__wrapper">
      <NavLink to="/ship/facilities" className="tools-widget__item">
        <img src="./assets/icons/find-a-facility.svg" alt="alert green" className="tools-widget__item-img"/>
        <p className="tools-widget__item-link">Find a Facility</p>
      </NavLink>
      <NavLink to="/learn/how-to-ship" className="tools-widget__item">
        <img src="./assets/icons/how-to-ship.svg" alt="alert blue" className="tools-widget__item-img"/>
        <p className="tools-widget__item-link">How to Ship</p>
      </NavLink>
      <NavLink to="/ship/apply/" className="tools-widget__item">
        <img src="./assets/icons/apply-now.svg" alt="alert orange" className="tools-widget__item-img"/>
        <p className="tools-widget__item-link">Apply Now</p>
      </NavLink>
    </div>
  </BlankComponent>
);

export default toolsWidget;



// WEBPACK FOOTER //
// ./src/components/ToolsWidget/ToolsWidget.js